import {
    FETCH_MY_PERMISSIONS,
    FETCH_MY_PERMISSIONS_SUCCESS,
    FETCH_MY_PERMISSIONS_FAILURE,
    CLEAR_PERMISSIONS,
} from './redux.actionTypes';

export const fetchMyPermissions = () => ({
    type: FETCH_MY_PERMISSIONS,
});

export const fetchMyPermissionsSuccess = (payload) => ({
    type: FETCH_MY_PERMISSIONS_SUCCESS,
    payload,
});

export const fetchMyPermissionsFailure = (error) => ({
    type: FETCH_MY_PERMISSIONS_FAILURE,
    payload: error,
});

export const clearPermissions = () => ({
    type: CLEAR_PERMISSIONS,
});
